import { Component, OnInit } from '@angular/core';
import { UserService } from './../../../services/user.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { department, interaction, division, user, usermaster, performancemaster } from './../../../models/admin';
import { AdminApiService } from './../../../services/admin.service';
import { uniqBy } from 'lodash';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  MenuCallbackArgs,

} from 'angular-slickgrid';
import { bmIncomingDashBoard, quater, bmOutgoingDashBoard, bmdashboardFilterValue, dashboardChart, benchmarkkpi, year } from './../../../models/slakpi';
import { BMApiService } from './../../../services/bm.service';

//import  htmlToPdfmake  from "html-to-pdfmake"

//import pdfMake from 'pdfmake/build/pdfmake';
//import pdfFonts from 'pdfmake/build/vfs_fonts';
//pdfMake.vfs = pdfFonts.pdfMake.vfs;
import html2pdf from 'html2pdf.js';
import { UtilityService } from '../../../services/utility.service';
import { SLAKPIApiService } from '../../../services/slakpi.service';
declare var google: any;
@Component({
  selector: 'app-bench-mark-chart-export',
  templateUrl: './bench-mark-chart-export.component.html',
  styleUrls: ['./bench-mark-chart-export.component.css']
})
export class BenchmarkChartExportComponent implements OnInit {
  chartOptionbenchmarkincomingoutgoingchart1: any = {};
  chartOptionbenchmarkincomingoutgoingchart2: any = {};

  chartOptionpracticebmdashboardchart01: any = {};
  chartOptionpracticebmdashboardchart02: any = {};

  chartOptionchartsummaryIn: any = {};
  chartOptionchartVisitorSatisification: any = {};
  chartOptionchartdashboardChart: any = {};
  chartOptionchartsummaryIndivision: any = {};
  chartOptiondashboardOrganizationChart: any = {};

  chartOptiondashboardChart: any = {};
  chartOptionconductedMeetingChart: any = {};

  public loading: boolean = true;

  public isAdmin: boolean = false;
  user: any = {};
  login_UserID: string; // number
  public user_data: any;
  public filterSettings: Object;

  public position_data: any = [];
  public peer_data: any = [];
  public map_data: any = [];

  progressCountList: any = [];
  objBMIncomingDashboardList: any = [];
  objBMOutgoingDashboardList: any = [];
  practiceBMTrackingList: any;

  public division_data: any;
  public benchMarkYear_data: any;
  public divisionUnofilter?: number = 0;
  public yearfilter?: number = 0;
  public quarterfilter?: number = 0;
  public quarterData: any;

  public isPerformance: boolean = true;
  public isPractice: boolean = false;
  public isIncoming: boolean = false;
  public isOutgoing: boolean = false;

  public isPerformance_Option1: boolean = true;
  public isPerformance_Option2: boolean = true;
  public isPerformance_Option3: boolean = true;

  public isPractice_Option1: boolean = true;
  public isPractice_Option2: boolean = true;

  public isIncoming_Option1: boolean = true;
  public isIncoming_Option2: boolean = true;
  public isIncoming_Option3: boolean = true;
  public isIncoming_Option4: boolean = true;
  public isIncoming_Option5: boolean = true;

  public isOutgoing_Option1: boolean = true;
  public isOutgoing_Option2: boolean = true;

  public isPerformancePageBreak: boolean = true;
  public isIncomingPageBreak1: boolean = true;
  public isIncomingPageBreak2: boolean = false;

  yearUno: number;
  public isBMChambion: boolean = false;
  public isBMTeam: boolean = false;
  public isBMVisitor: boolean = false;
  public isBMAdmin: boolean = false;
  noDataImg: any;
  tenantUno: any;
  positionTotal: number = 0;
  kpiUno: string = "";
  positionUno: any = 0;
  BMPosition_data: any = [];
  kpi_data: any = [];
  yearData: any = [];
  isConsolidateReport: boolean = false;
  constructor(private router: Router, private userService: UserService, public utilityService: UtilityService, public restApi: AdminApiService, public restBMApi: BMApiService, public restSLAKPIApi: SLAKPIApiService, private spinner: SpinnerVisibilityService) { //To Validate User Permission
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.yearUno = Number(this.user.currentYear);
    this.ValidateUserAccess();
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
  }

  //Method used To Validate User Permission
  ValidateUserAccess() {

    
    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'BM Administrator') ? true : false;
    // this.CheckUserPermission();
    if (this.user.role == 'BM Champions')
      this.isBMChambion = true;
    if (this.user.role == 'BM Team')
      this.isBMTeam = true;
    if (this.user.role == 'BM Visitor')
      this.isBMVisitor = true;
    if (this.user.role == 'BM Administrator') { this.isBMAdmin = true; }
    if (!this.isAdmin && !this.isBMChambion && !this.isBMTeam && !this.isBMVisitor && !this.isBMAdmin)
      this.router.navigateByUrl('/access-denied');

  }


  ngOnInit() {
    this.userService.CheckLogin();
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.yearfilter = 0;//Number(this.user.currentYear);
    this.quarterfilter = 0;//Number(this.user.currentQuarter);
    this.isAdmin = (this.user.role == 'Administrator') ? true : false;
    //if (!this.isAdmin) {
    //  this.router.navigateByUrl('/access-denied/');
    //}
    if (this.isBMChambion) {
      this.divisionUnofilter = (this.user.divisionUno != '') ? parseInt(this.user.divisionUno) : 0;
    }
    this.getBenchMarkYear();
    this.getDivisions();
    this.loadYear();
    this.loadQuater();
    this.getPositionData();
    this.loadBenchMarkKPI();

    this.getPerformanceDashboard();
    this.getPracticeDashboardChart();
    this.getPraticeBMTrackingDashboardChart();
    this.getBMIncomingDashboardList();
    this.getBMOutgoingDashboardList();

  }

  loadQuater() {

    let inpValue = new quater();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.tenantUno = 1;
    inpValue.userUno = this.login_UserID;
    
    this.restBMApi.getQuaterMaster(inpValue)
      .subscribe(data => {
        
        this.quarterData = data;

      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }
  loadYear() {

    let inpValue = new year();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    
    this.restSLAKPIApi.getYearMaster(inpValue)
      .subscribe(data => {
        
        this.yearData = data;

      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }
  getPositionData() {
    this.spinner.show();
    let inpValue = new performancemaster();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.tenantUno = this.tenantUno;
    inpValue.condition = 1;
    inpValue.userUno = this.login_UserID;
    inpValue.tableName = 'position';

    this.restApi.getPerformanceMaster(inpValue)
      .subscribe(data => {
        
        this.BMPosition_data = data;
        //else if (this.pfmType == "position") {
        //         mockDataset[i] = {
        //           id: this.data[i].id,
        //           titleNameEn: this.data[i].titleNameEn
        //         };
        //       }

      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  loadBenchMarkKPI() {
    this.spinner.show();

    let inpValue = new benchmarkkpi();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    inpValue.frequencyUno = 0;
    inpValue.slaRuleUno = 0;
    inpValue.businessDivisionUno = (typeof this.divisionUnofilter != 'undefined' && this.divisionUnofilter) ? this.divisionUnofilter : 0;
    inpValue.reportingDivisionUno = 0;

    this.restBMApi.getBenchMarkKPIs(inpValue)
      .subscribe(data => {

        this.kpi_data = data;
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }

  //* Performance Chart --Start*//
  public getPerformanceDashboard() {
    this.spinner.show();
    let inpValue = new bmdashboardFilterValue();
    inpValue.yearuno = (typeof this.yearfilter != 'undefined' && this.yearfilter) ? this.yearfilter : 0;
    inpValue.businessDivisionUno = (typeof this.divisionUnofilter != 'undefined' && this.divisionUnofilter) ? this.divisionUnofilter : 0;
    inpValue.positionUno = (typeof this.positionUno != 'undefined' && this.positionUno) ? this.positionUno : 0;
    inpValue.strKPIUno = (typeof this.kpiUno != 'undefined' && this.kpiUno.length > 0) ? this.kpiUno.toString() : "";
    //inpValue.trendUno = 0;//(typeof this.trendUno != 'undefined' && this.trendUno) ? this.trendUno : 0;
    inpValue.userUno = this.login_UserID;
    this.spinner.show();
    
    this.restBMApi.getBMDashboard(inpValue)
      .subscribe(data => {

        let objdata: any = data;
        this.position_data = (objdata.positionData != null) ? objdata.positionData : [];
        this.peer_data = (objdata.peerData != null) ? objdata.peerData : [];
        this.map_data = (objdata.mapData != null) ? objdata.mapData : [];

        
        this.positionTotal = 0;
        for (var i = 0; i < this.position_data.length; i++) {
          this.positionTotal += parseInt(this.position_data[i].actualValue);
        }
        for (var i = 0; i < this.peer_data.length; i++) {
          this.positionTotal += parseInt(this.peer_data[i].actualValue);
        }
        
        if (this.position_data.length > 0) {
          setTimeout(() => {

            this.benchmarkincomingoutgoingchart1(this.positionTotal);
          }, 100);
        }
        if (this.peer_data.length > 0) {
          setTimeout(() => {

            this.benchmarkincomingoutgoingchart2(this.positionTotal);
          }, 100);
        }

        if (this.position_data.length > 0) {
          google.charts.load('current', { 'packages': ['corechart'] });
          google.charts.setOnLoadCallback(this.benchmarkincomingoutgoingchart1);
        }
        if (this.peer_data.length > 0) {
          google.charts.load('current', { 'packages': ['corechart'] });
          google.charts.setOnLoadCallback(this.benchmarkincomingoutgoingchart2);
        }
        google.charts.load('current', {
          'packages': ['geochart'],
          'mapsApiKey': 'AIzaSyD-9tSrke72PouQMnMX-a7eZSW0jkFMBWY'
        });
        google.charts.setOnLoadCallback(this.benchmarkincomingoutgoingchartworld);

        this.spinner.hide();
      },
        (error) => {
          this.spinner.hide();
        }
      ).add(() => {
        this.spinner.hide();
      });

  }
  benchmarkincomingoutgoingchart1(positionTotal: any) {

    let tempArray = [];


    

    //"top decile"
    var objTopDecile = this.position_data.filter(item => item.id == 9);
    if (objTopDecile.length > 0) {
      tempArray.push({ name: objTopDecile[0].positionName, value: objTopDecile[0].actualValue });

    }

    //
    var objTopQuartile = this.position_data.filter(item => item.id == 7);
    if (objTopQuartile.length > 0) {
      tempArray.push({ name: objTopQuartile[0].positionName, value: objTopQuartile[0].actualValue });

    }
    //"median"
    var objMedian = this.position_data.filter(item => item.id == 4);
    if (objMedian.length > 0) {
      tempArray.push({ name: objMedian[0].positionName, value: objMedian[0].actualValue });

    }
    //"bottom quartile"
    var objBottomQuartile = this.position_data.filter(item => item.id == 3);
    if (objBottomQuartile.length > 0) {
      tempArray.push({ name: objBottomQuartile[0].positionName, value: objBottomQuartile[0].actualValue });

    }
    


    //echarts starts
    this.chartOptionbenchmarkincomingoutgoingchart1 = {
      tooltip: {
        trigger: "item",
        formatter: "{c}",
        textStyle: {
          fontWeight: "bold",
          fontSize: 13
        }
      },
      color: ['#68b097', '#83ceb1', '#aaebac', '#E74C3C', '#efa96c', '#de8060', '#a44b2d', '#428893'],
      legend: {
        bottom: '0',
        // left: 'left'
      },
      series: [
        {
          name: '',
          type: 'pie',
          radius: ['30%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: true,
            position: 'inside',
            color: '#fff',
            fontSize: '12',
            formatter: function (d) {
              return Math.round((d.value / positionTotal) * 100) + '%';
            }
          },
          emphasis: {
            label: {
              show: true,
              fontSize: '10',
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: true
          },
          data: tempArray
        }
      ]
    };
    // echarts ends

    //const chart = new google.visualization.PieChart(document.getElementById('benchmarkincomingoutgoingchart1'));
    //chart.draw(data, options);
  }






  benchmarkincomingoutgoingchart2(positionTotal: any) {

    let tempArray = [];

    //"exceeding peer"
    var objExceedingPeer = this.peer_data.filter(item => item.id == 1);
    if (objExceedingPeer.length > 0) {
      tempArray.push({ name: objExceedingPeer[0].peerName, value: objExceedingPeer[0].actualValue });

    }



    //item.peerName.toLowerCase() == "similar performance"
    var objSimilarPerformance = this.peer_data.filter(item => item.id == 8);
    if (objSimilarPerformance.length > 0) {
      tempArray.push({ name: objSimilarPerformance[0].peerName, value: objSimilarPerformance[0].actualValue });

    }
    //"below peer"
    var objBelowPeer = this.peer_data.filter(item => item.id == 2);
    if (objBelowPeer.length > 0) {
      tempArray.push({ name: objBelowPeer[0].peerName, value: objBelowPeer[0].actualValue });

    }
    //echarts starts
    this.chartOptionbenchmarkincomingoutgoingchart2 = {
      tooltip: {
        trigger: "item",
        formatter: "{c}",
        textStyle: {
          fontWeight: "bold",
          fontSize: 13
        }
      },
      legend: {
        bottom: '0',
        left: 'center'
      },
      color: ['#68b097', '#aaebac', '#E74C3C', '#f5d17a', '#efa96c', '#de8060', '#a44b2d', '#428893'],
      series: [
        {
          name: '',
          type: 'pie',
          radius: ['30%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: true,
            position: 'inside',
            color: '#fff',
            fontSize: '12',
            formatter: function (d) {
              return Math.round((d.value / positionTotal) * 100) + '%';
            }
          },
          emphasis: {
            label: {
              show: true,
              fontSize: '10',
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: true
          },
          data: tempArray
        }
      ]
    };
    // echarts ends
  }
  benchmarkincomingoutgoingchartworld = () => {
    let tempArray = [['Country', 'Contribution']];
    for (var i = 0; i < this.map_data.length; i++) {
      
      tempArray.push([this.map_data[i].country, parseInt(this.map_data[i].noofPeer)]);
    }
    const data = google.visualization.arrayToDataTable(tempArray);
    /*[
          ['Country', 'Popularity'],
          ['Germany', 200],
          ['United States', 300],
          ['Brazil', 400],
          ['Canada', 500],
          ['France', 600],
          ['RU', 700]
    
        ]*/
    const options = {
      //title: 'DEWA Benchmarking position categories against peers',
      colors: ['#04bdae']
      //slices: {
      //  0: { color: '#04bdae' },
      //  1: { color: '#367cd2' },
      //  2: { color: '#404041' },
      //  3: { color: '#68b080' },
      //  4: { color: '#0b937e' },
      //  5: { color: '#d5d5d5' },
      //  6: { color: '#fcba03' },
      //  7: { color: '#07db0a' },
      //  8: { color: '#04d4bb' }
      //}

    };

    const chart = new google.visualization.GeoChart(document.getElementById('benchmarkincomingoutgoingchartworld'));
    chart.draw(data, options);

    //For Consolidate
    const chart1 = new google.visualization.GeoChart(document.getElementById('benchmarkincomingoutgoingchartworld1'));
    chart1.draw(data, options);
  }
  //* Performance Chart --End*//

  //* Practice Chart --Start*//
  getPracticeDashboardChart() {
    
    this.spinner.show();
    let inpValue = new dashboardChart();
    inpValue.id = 0;
    inpValue.userUno = this.login_UserID;
    inpValue.condition = 0;
    inpValue.division = (this.divisionUnofilter != null) ? this.divisionUnofilter.toString() : "0";
    this.restBMApi.getDashboardChart(inpValue)
      .subscribe(data => {
        
        this.progressCountList = data;

        if (!(this.progressCountList[0].planCount == "0" && this.progressCountList[0].adaptCount == "0" && this.progressCountList[0].analyseCount == "0" && this.progressCountList[0].collectCount == "0")) {
          setTimeout(() => {
            this.practicebmdashboardchart01();
          }, 200);
        }
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  practicebmdashboardchart01() {
    
    let tempArray = [];

    //tempArray.push(['Plan', this.progressCountList[0].planCount]);
    //tempArray.push(['Collect', this.progressCountList[0].collectCount]);
    //tempArray.push(['Adapt', '50']);
    //tempArray.push(['Analyze', '70']);






    ////const data = google.visualization.arrayToDataTable([
    ////  ['Benchmark', 'Percentage'],

    ////  ['Plan', 30],
    ////  ['Collect', 30],
    ////  ['Adapt', 20],
    ////  ['Analyze', 20]
    ////]);
    //var data = google.visualization.arrayToDataTable(tempArray);
    //const options = {
    //  //title: 'SLA Performance Summary',
    //  colors: ['#4472c4', '#43beb9', '#70ad47','#45b664'],
    //  legend: { position: 'none' },
    //  chartArea: { left: 10, top: 10, bottom: 10, width: "100%", height: "100%" }
    //};

    //const chart = new google.visualization.PieChart(document.getElementById('practice-bm-dashboard-chart01'));
    //chart.draw(data, options);

    tempArray = ([

      { name: 'Plan', value: (this.progressCountList[0].planCount != '') ? parseInt(this.progressCountList[0].planCount) : 0 },
      { name: 'Collect', value: (this.progressCountList[0].collectCount != '') ? Math.round(parseInt(this.progressCountList[0].collectCount)) : 0 },
      { name: 'Adapt', value: (this.progressCountList[0].adaptCount != '') ? Math.round(parseInt(this.progressCountList[0].adaptCount)) : 0 },
      { name: 'Analyze', value: (this.progressCountList[0].analyseCount != '') ? Math.round(parseInt(this.progressCountList[0].analyseCount)) : 0 }

    ]);
    let totalval = ((this.progressCountList[0].planCount != '') ? parseInt(this.progressCountList[0].planCount) : 0) +
      ((this.progressCountList[0].collectCount != '') ? Math.round(parseInt(this.progressCountList[0].collectCount)) : 0) +
      ((this.progressCountList[0].adaptCount != '') ? Math.round(parseInt(this.progressCountList[0].adaptCount)) : 0) +
      ((this.progressCountList[0].analyseCount != '') ? Math.round(parseInt(this.progressCountList[0].analyseCount)) : 0);
    var options = {
      //title: 'Progress Chart',
      color: ['#68b097', '#83ceb1', '#aaebac', '#f5d17a', '#efa96c', '#de8060', '#a44b2d', '#428893'],
      //legend: { position: 'right' },
      fontSize: 15,
      legend: {
        textStyle: {
          fontSize: 12
        },
        position: 'right'
      },
      chartArea: { left: 0, right: 0, top: 0, bottom: 10, width: "80%", height: "100%" }
    };


    //echarts starts
    this.chartOptionpracticebmdashboardchart01 = {
      tooltip: {
        trigger: "item",
        formatter: "{c}",
        textStyle: {
          fontWeight: "bold",
          fontSize: 13
        }
      },

      legend: {
        bottom: '0',
        left: 'center',
        //orient: "vertical",

        //padding: [
        //  20,  // up
        //  20, // right
        //  0,  // down
        //  0, // left
        //],
      },
      color: ['#68b097', '#83ceb1', '#aaebac', '#f5d17a', '#efa96c', '#de8060', '#a44b2d', '#428893'],
      series: [
        {
          name: '',
          type: 'pie',
          radius: ['30%', '80%'],
          center: ["50%", "43%"],
          avoidLabelOverlap: false,
          label: {
            show: true,
            position: 'inside',
            color: '#fff',
            fontSize: '12',
            formatter: function (d) {
              return Math.round((d.value / totalval) * 100) + '%';
            }
          },
          emphasis: {
            label: {
              show: true,
              fontSize: '10',
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: true
          },

          data: tempArray
        }
      ]
    };
    // echarts ends



    //var chart = new google.visualization.PieChart(document.getElementById('practice-bm-dashboard-chart01'));

    //chart.draw(data, options);
  }
  getPraticeBMTrackingDashboardChart() {
    this.spinner.show();
    let inpValue = new dashboardChart();
    inpValue.id = 0;
    inpValue.userUno = this.login_UserID;
    inpValue.condition = 2;
    inpValue.division = (this.divisionUnofilter != null) ? this.divisionUnofilter.toString() : "0";
    this.restBMApi.getDashboardChart(inpValue)
      .subscribe(data => {
        
        this.practiceBMTrackingList = data;
        if (this.practiceBMTrackingList[0].objListPracticeBMTracking.length > 0)
          setTimeout(() => {
            this.practicebmdashboardchart02(this.practiceBMTrackingList[0].objListPracticeBMTracking);
          }, 200);
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  practicebmdashboardchart02 = (option_data: any) => {

    
    let tempArray = [];
    let tempArraydiv = [];

    let temparrTotalProject = [];
    let temparrTotalProjectonTrack = [];
    let temparrTotalProjectSmall = [];
    let temparrTotalProjectCritical = [];
    let temparrTotalProjectProjectCompleted = [];

    for (var i = 0; i < option_data.length; i++) {
      temparrTotalProject.push(option_data[i].totalProjects);
      temparrTotalProjectonTrack.push(option_data[i].projectOnTrack);
      temparrTotalProjectSmall.push(option_data[i].smallVariance);
      temparrTotalProjectCritical.push(option_data[i].criticalVariance);
      temparrTotalProjectProjectCompleted.push(option_data[i].projectCompleted);
      tempArraydiv.push(option_data[i].division);
    }
    tempArray.push(
      { name: 'Total Project', type: 'bar', data: temparrTotalProject }, { name: 'Project on Track', type: 'bar', data: temparrTotalProjectonTrack }, { name: 'Small varaiance', type: 'bar', data: temparrTotalProjectSmall }, { name: 'Critical variance', type: 'bar', data: temparrTotalProjectCritical }, { name: 'Project Completed', type: 'bar', data: temparrTotalProjectProjectCompleted });

    //const data = google.visualization.arrayToDataTable([
    //  ['Division', 'Total Project', 'Project on Track', 'Small varaiance', 'Critical variance', 'Project Completed'],
    //  ['Water and Civil', 50, 40, 10, 30,  35],
    //  ['Distribution Power ', 60, 50, 20, 20,  40],
    //  ['Division3', 50, 40, 20, 35,  30],
    //  ['Division4', 40, 30, 10, 25,  25],
    //  ['Strategy & Government Communication', 30, 20, 10, 15,  20]
    //]);

    //  var data = google.visualization.arrayToDataTable(tempArray);


    //echarts starts
    this.chartOptionpracticebmdashboardchart02 = {
      title: {
        text: '',
        subtext: ''
      },
      color: ['#68b097', '#83ceb1', '#aaebac', '#f5d17a', '#efa96c', '#de8060', '#a44b2d', '#428893'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      legend: {
        data: ['Total Project', 'Project on Track', 'Small varaiance', 'Critical variance', 'Project Completed'],
        bottom: '2',
        left: 'center',
        //padding: [
        //  20,  // up
        //  0, // right
        //  0,  // down
        //  0, // left
        //],
      },
      grid: {
        left: '0',
        top: '10%',
        right: '0',
        bottom: '20%',
        containLabel: true
      },
      yAxis: {
        type: 'value',
        boundaryGap: [0, 0.01]
      },
      xAxis: {
        type: 'category',
        data: tempArraydiv
      },
      series: tempArray
    };
    // echarts ends


  }
  //* Practice Chart --End*//

  //* Incoming Chart --Start *//
  getBMIncomingDashboardList() {
    

    let inpValue = new bmIncomingDashBoard();
    inpValue.organization = '';
    inpValue.division = this.divisionUnofilter ? this.divisionUnofilter : 0;
    inpValue.year = this.yearfilter ? this.yearfilter : 0;
    // inpValue.quarter = 0;//this.quarterfilter ? this.quarterfilter : 0;
    inpValue.quarter = this.quarterfilter ? this.quarterfilter : 0;
    inpValue.userUno = this.login_UserID;
    this.restBMApi.getBMIncomingDashboard(inpValue)
      .subscribe(data => {
        
        if (data != null) {
          this.objBMIncomingDashboardList = data[0];

          this.loading = false;


          
          //if (this.objBMIncomingDashboardList.happinessRating.length > 0) {
          //  this.spinner.show();
          //  setTimeout(() => {
          //    this.dashboardChart(this.objBMIncomingDashboardList.happinessRating);
          //    this.spinner.hide();
          //  }, 200);
          //}

          // No Of meeting
          if (this.objBMIncomingDashboardList.summaryofMeetingStatus.length > 0) {
            this.spinner.show();
            setTimeout(() => {

              this.dashboardChart(this.objBMIncomingDashboardList.summaryofMeetingStatus);
              this.spinner.hide();
            }, 400);
          }

          if (this.objBMIncomingDashboardList.summaryofIncomingVisits.length > 0) {
            this.spinner.show();
            setTimeout(() => {
              this.summaryIncommingChart(this.objBMIncomingDashboardList.summaryofIncomingVisits);


              this.spinner.hide();
            }, 100);
          }

          if (this.objBMIncomingDashboardList.visitorSatification.length > 0) {
            this.spinner.show();
            setTimeout(() => {

              this.visitorSatisfactionChart(this.objBMIncomingDashboardList.visitorSatification);


              this.spinner.hide();
            }, 100);
          }

          if (this.objBMIncomingDashboardList.visitorPerDivision.length > 0) {
            this.spinner.show();
            setTimeout(() => {
              this.visitperDivisionChart(this.objBMIncomingDashboardList.visitorPerDivision);
              this.spinner.hide();
            }, 100);
          }

          if (this.objBMIncomingDashboardList.summaryofOrganizationType.length > 0) {
            this.spinner.show();
            setTimeout(() => {
              this.dashboardOrganizationChart(this.objBMIncomingDashboardList.summaryofOrganizationType);
              this.spinner.hide();
            }, 200);
          }

          //if (this.objBMIncomingDashboardList.summaryofIncomingVisits.length > 0) {
          //  this.spinner.show();
          //  setTimeout(() => {
          //    google.charts.load('current', { 'packages': ['table'] });
          //    google.charts.setOnLoadCallback(this.upcommingVisitChart(this.objBMIncomingDashboardList.summaryofIncomingVisits));


          //    this.spinner.hide();
          //  }, 900);
          //}

        }

        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });


  }

  dashboardChart = (option_data: any) => {
    
    let tempArray = [];


    
    let uniqueYear = this.uniqueArray(option_data, 'year', 'year');
    let tempArrayAsc = uniqueYear.sort((a, b) => b.value - a.value);
    let lst4Year = tempArrayAsc.slice(0, 4);
    lst4Year = lst4Year.sort((a, b) => a.value - b.value);

    //let tempArrayAsc = uniqueYear.sort((a, b) => a.value - b.value);
    //uniqueYear = uniqueYear.sort((a, b) => a.value - b.value);

    //let tempArray_Year = ["2020","2021"];
    //let temparrConducted = [5,10];
    //let temparrOnHold = [20, 30];
    //let temparrOnGoing = [22];
    //let temparrNoResponse = [34];

    let tempArray_Year = [];
    let temparrConducted = [];
    let temparrOnHold = [];
    let temparrOnGoing = [];
    let temparrNoResponse = [];

    for (var i = 0; i < lst4Year.length; i++) {
      tempArray_Year.push(lst4Year[i].value);
      
      let filterData = option_data.filter(x => x.year == lst4Year[i].value);
      //Conducted
      let filterConductedData = filterData.filter(x => x.statusName.toLowerCase() == "Conducted".toLowerCase());
      if (filterConductedData.length > 0) {
        temparrConducted.push(filterConductedData[0].noofMeeting);
      }
      else {
        temparrConducted.push(0);
      }

      //On Hold
      let filterOnHoldData = filterData.filter(x => x.statusName.toLowerCase() == "On Hold".toLowerCase());
      if (filterOnHoldData.length > 0) {
        temparrOnHold.push(filterOnHoldData[0].noofMeeting);
      }
      else {
        temparrOnHold.push(0);
      }

      //In Progress
      let filterInProgressData = filterData.filter(x => x.statusName.toLowerCase() == "In Progress".toLowerCase());
      if (filterInProgressData.length > 0) {
        temparrOnGoing.push(filterInProgressData[0].noofMeeting);
      }
      else {
        temparrOnGoing.push(0);
      }

      //NO Response
      let filterNOResponseData = filterData.filter(x => x.statusName.toLowerCase() == "NO Response".toLowerCase());
      if (filterNOResponseData.length > 0) {
        temparrNoResponse.push(filterNOResponseData[0].noofMeeting);
      }
      else {
        temparrNoResponse.push(0);
      }

    }




    tempArray.push(
      { name: 'Conducted', type: 'bar', data: temparrConducted,label: { show: true, position: 'top' } },
      { name: 'On Hold', type: 'bar', data: temparrOnHold, label: { show: true, position: 'top' } },
      { name: 'In Progress', type: 'bar', data: temparrOnGoing, label: { show: true, position: 'top' } },
      { name: 'No Response', type: 'bar', data: temparrNoResponse, label: { show: true, position: 'top' } }
    );
    

    //echarts starts
    this.chartOptionchartdashboardChart = {
      title: {
        text: '',
        subtext: ''
      },
      color: ['#68b097', '#83ceb1', '#aaebac', '#f5d17a', '#efa96c', '#de8060', '#a44b2d', '#428893'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      legend: {
        data: ['Total Approved Request by Received', 'Fulfilled Visit'],
        bottom: '0',
        left: 'center',
        //padding: [
        //  20,  // up
        //  0, // right
        //  0,  // down
        //  0, // left
        //],
      },
      grid: {
        left: '5%',
        top: '10%',
        right: '0',
        bottom: '10%',
        containLabel: true
      },
      barWidth: "20%",
      yAxis: {
        name: 'No of count',
        nameLocation: 'middle',
        nameGap: 35,
        type: 'value',
        boundaryGap: [0, 0.01]
      },
      xAxis: {
        name: 'Year',
        nameLocation: 'middle',
        nameGap: 40,
        type: 'category',
        data: tempArray_Year
      },
      series: tempArray
    };
    // echarts ends
  }

  //dashboardChart = (option_data: any) => {
  //  
  //  let tempArray = [];
  //  let tempArray_Organization = [];
  //  let tempArray_Happiness = [];
  //  for (var i = 0; i < option_data.length; i++) {
  //    if (parseInt(option_data[i].happinessRate) > 0) {
  //      tempArray_Happiness.push(parseInt(option_data[i].happinessRate));

  //      tempArray_Organization.push(option_data[i].organization)
  //    }
  //  }
  //  tempArray.push({ name: "", type: 'bar', data: tempArray_Happiness });

  //  //echarts starts
  //  this.chartOptionchartdashboardChart = {
  //    tooltip: {
  //      trigger: 'axis',
  //      axisPointer: {
  //        type: 'cross',
  //        crossStyle: {
  //          color: '#999'
  //        }
  //      }
  //    },
  //    color: ['#68b097', '#83ceb1', '#aaebac', '#f5d17a', '#efa96c', '#de8060', '#a44b2d', '#428893'],
  //    grid: {
  //      left: '0',
  //      top: '10%',
  //      right: '0',
  //      bottom: '10%',
  //      containLabel: true
  //    },
  //    barWidth: "20%",
  //    toolbox: {
  //      feature: {

  //        //magicType: { show: true, type: ['line', 'bar'] },
  //        //restore: { show: true },
  //        //saveAsImage: { show: true }
  //      }
  //    },
  //    legend: {
  //      data: ['Happiness Rate'],
  //      bottom: '0',
  //      left: 'center',
  //      //padding: [
  //      //  20,  // up
  //      //  0, // right
  //      //  0,  // down
  //      //  0, // left
  //      //],
  //    },
  //    xAxis: {
  //      type: 'category',
  //      data: tempArray_Organization,
  //      axisLabel: {

  //      }
  //    },
  //    yAxis: {
  //      type: 'value'
  //    },
  //    series: tempArray

  //  };
  //   // echarts ends


  //  //const chart = new google.visualization.ComboChart(document.getElementById('dashboardChart'));
  //  //chart.draw(data, options);
  //  }

  summaryIncommingChart = (option_data: any) => {
    
    let tempArray = [];
    let tempArray_Year = [];
    let temparrTotalApproved = [];
    let temparrTotalFulfilled = [];
    //tempArray.push(['Quarter', 'Total Approved Received Request', 'Fulfilled Visit', 'Pending Request In-Progress', 'Cancelled Request']);
    // tempArray.push();
    //tempArray.push(['2021/Q1', 39, 30, 15, 18]);

    //for (var i = 0; i < option_data.length; i++) {
    //  tempArray.push([option_data[i].type, option_data[i].receivedQY, parseInt(option_data[i].totalApproved)]);
    //}
    for (var i = 0; i < option_data.length; i++) {
      tempArray_Year.push(option_data[i].quarter);
      temparrTotalApproved.push(option_data[i].column1);
      temparrTotalFulfilled.push(option_data[i].column2);
    }
    tempArray.push(
      { name: 'Total Approved Request by Received', type: 'bar', data: temparrTotalApproved }, { name: 'Fulfilled Visit', type: 'bar', data: temparrTotalFulfilled });
    

    //echarts starts
    this.chartOptionchartsummaryIn = {
      title: {
        text: '',
        subtext: ''
      },
      color: ['#68b097', '#83ceb1', '#aaebac', '#f5d17a', '#efa96c', '#de8060', '#a44b2d', '#428893'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      legend: {
        data: ['Total Approved Request by Received', 'Fulfilled Visit'],
        bottom: '0',
        left: 'center',
        //padding: [
        //  20,  // up
        //  0, // right
        //  0,  // down
        //  0, // left
        //],
      },
      grid: {
        left: '0',
        top: '10%',
        right: '0',
        bottom: '10%',
        containLabel: true
      },
      barWidth: "20%",
      yAxis: {
        type: 'value',
        boundaryGap: [0, 0.01]
      },
      xAxis: {
        type: 'category',
        data: tempArray_Year
      },
      series: tempArray
    };
    // echarts ends

  }

  visitorSatisfactionChart = (option_data: any) => {

    let tempArray = [];
    let tempArray_Year = [];
    let temparrTotalActual = [];
    let temparrTotalTarget = [];

    for (var i = 0; i < option_data.length; i++) {
      tempArray_Year.push(option_data[i].receivedQY);
      let SatificationRate = (option_data[i].satificationRate != "") ? (parseFloat(option_data[i].satificationRate)) : 0.00
      temparrTotalActual.push(parseFloat(SatificationRate.toString()).toFixed(2));
      temparrTotalTarget.push(parseInt(option_data[i].target));

    }


    tempArray.push(
      { name: 'Actual', type: 'bar', data: temparrTotalActual, label: { show: true, position: 'top' } },
      { name: 'Target', type: 'bar', data: temparrTotalTarget, label: { show: true, position: 'top' } }
    );
    

    //echarts starts
    this.chartOptionchartVisitorSatisification = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          crossStyle: {
            color: '#999'
          }
        }
      },
      color: ['#68b097', '#83ceb1', '#aaebac', '#f5d17a', '#efa96c', '#de8060', '#a44b2d', '#428893'],
      grid: {
        left: '5%',
        top: '10%',
        right: '0',
        bottom: '20%',
        containLabel: true
      },
      toolbox: {
        feature: {

          //magicType: { show: true, type: ['line', 'bar'] },
          //restore: { show: true },
          //saveAsImage: { show: true }
        }
      },
      barWidth: "20%",
      legend: {
        data: ['Actual', 'Target'],
        bottom: '0',
        left: 'center',
        //padding: [
        //  20,  // up
        //  0, // right
        //  0,  // down
        //  0, // left
        //],
      },
      xAxis: [
        {
          name: 'Year',
          nameLocation: 'middle',
          nameGap: 40,
          type: 'category',
          data: tempArray_Year,
          axisPointer: {
            type: 'shadow'
          }
        }
      ],
      yAxis: [{
        name: 'Happiness Percentage',
        nameLocation: 'middle',
        nameGap: 45,
        type: "value",
       // min: 96,

        axisLabel: {
          formatter: "{value}%"
        }
      }],
      series: tempArray
    };
    // echarts ends



    //var chart = new google.visualization.ComboChart(document.getElementById('chart_VisitorSatisification'));
    //chart.draw(data, options);

  }
  visitperDivisionChart = (option_data: any) => {

    // let tempArray = [['Division', 'Visit Count']];
    let tempArray = [];

    for (var i = 0; i < option_data.length; i++) {

      tempArray.push({ name: this.sentenceCase(option_data[i].divisionName), value: parseInt(option_data[i].divisionCount) });
      //  temparrTotalActual.push();
    }
    



    //echarts starts
    this.chartOptionchartsummaryIndivision = {
      tooltip: {
        trigger: "item",
        formatter: "{c}",
        textStyle: {
          fontWeight: "bold",
          fontSize: 13
        }
      },

      legend: {
        type: 'scroll',
        orient: 'vertical',
        right: -30,
        top: 0,
        bottom: 20,
        pageIconColor: '#087b36',
        pageIconInactiveColor: '#999999'
      },
      color: ['#68b097', '#83ceb1', '#aaebac', '#f5d17a', '#efa96c', '#de8060', '#a44b2d', '#428893'],

      series: [
        {
          name: '',
          type: 'pie',
          //radius: ['30%', '80%'],
          center: ["25%", "50%"],
          avoidLabelOverlap: false,
          label: {
            show: true,
            position: 'inside',
            color: '#fff',
            fontSize: '12',
            formatter: function (d) {
              return d.value;
            }
          },
          emphasis: {
            label: {
              show: true,
              fontSize: '10',
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: true
          },

          data: tempArray
        }
      ]
    };
    // echarts ends



    //var chart = new google.visualization.PieChart(document.getElementById('chart_summaryIn_division'));
    //chart.draw(data, options);

  }

  upcommingVisitChart = (option_data: any) => {

    let tempArray = [['Type', 'Quarter', 'Visit Count']];
    for (var i = 0; i < option_data.length; i++) {
      tempArray.push([option_data[i].type, option_data[i].receivedQY, parseInt(option_data[i].totalApproved)]);
    }
    

    //var data = new google.visualization.arrayToDataTable(tempArray);

    var data = new google.visualization.DataTable();
    data.addColumn('string', 'Request From');
    data.addColumn('string', 'Request Topic');
    data.addColumn('string', 'Organisation Type');
    data.addRows([
      ['Dubai Police', 'service level', 'Government'],
      ['Emirates Global Aluminum', 'General Tpoic', 'Private'],
      ['Dubai Government Workshop', 'General Tpoic', 'Government'],
      ['Smart Dubai', 'General Tpoic', 'Government']
    ]);

    var table = new google.visualization.Table(document.getElementById('chart_upcommingVisit'));

    table.draw(data, { showRowNumber: true, width: '100%', height: '100%' });

  }


  dashboardOrganizationChart = (option_data: any) => {
    
    let tempArray = [];
    //for (var i = 0; i < option_data.length; i++) {
    //tempArray.push([option_data[i].organization, parseInt(option_data[i].happinessRate)]);
    //}
    tempArray.push({ name: 'Government', value: option_data[0].noOfGovernment }, { name: 'Private', value: option_data[0].noOfPrivate }, { name: 'Semi Government', value: option_data[0].noOfSemiGovernment });


    //echarts starts
    this.chartOptiondashboardOrganizationChart = {
      tooltip: {
        trigger: "item",
        formatter: "{c}",
        textStyle: {
          fontWeight: "bold",
          fontSize: 13
        }
      },

      legend: {
        bottom: '0',
        left: 'center',
        //orient: "vertical",

        //padding: [
        //  20,  // up
        //  20, // right
        //  0,  // down
        //  0, // left
        //],
      },
      color: ['#68b097', '#83ceb1', '#aaebac', '#f5d17a', '#efa96c', '#de8060', '#a44b2d', '#428893'],
      series: [
        {
          name: '',
          type: 'pie',
          radius: ['30%', '80%'],
          center: ["50%", "40%"],
          avoidLabelOverlap: false,
          label: {
            show: true,
            position: 'inside',
            color: '#fff',
            fontSize: '12',
            formatter: function (d) {
              return d.value;
            }
          },
          emphasis: {
            label: {
              show: true,
              fontSize: '10',
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: true
          },

          data: tempArray
        }
      ]
    };
    // echarts ends



    //const chart = new google.visualization.PieChart(document.getElementById('dashboardOrganizationChart'));
    //chart.draw(data, options);
  }
  //* Incoming Chart --End *//


  //* Outgoing Chart --Start *//
  getBMOutgoingDashboardList() {
    
    let inpValue = new bmOutgoingDashBoard();
    inpValue.organization = '';
    inpValue.division = this.divisionUnofilter ? this.divisionUnofilter : 0;
    inpValue.year = this.yearfilter ? this.yearfilter : 0;
    inpValue.quarter = this.quarterfilter ? this.quarterfilter : 0;
    inpValue.userUno = this.login_UserID;
    
    this.restBMApi.getBMOutgoingDashboard(inpValue)
      .subscribe(data => {
        
        if (data != null) {
          this.objBMOutgoingDashboardList = data[0];


          this.loading = false;



          if (this.objBMOutgoingDashboardList.summaryofOrganizationType.length > 0) {
            this.spinner.show();
            setTimeout(() => {
              this.summaryofOrganizationTypeChart(this.objBMOutgoingDashboardList.summaryofOrganizationType);
              this.spinner.hide();
            }, 200);
          }



          if (this.objBMOutgoingDashboardList.summaryofConductedMeeting.length > 0) {
            this.spinner.show();
            setTimeout(() => {
              this.conductedMeetingChart(this.objBMOutgoingDashboardList.summaryofConductedMeeting);


              this.spinner.hide();
            }, 200);
          }
        }
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
  summaryofOrganizationTypeChart = (option_data: any) => {
    

    //for (var i = 0; i < option_data.length; i++) {
    //tempArray.push([option_data[i].organization, parseInt(option_data[i].happinessRate)]);
    //} 

    let tempArray = [];
    let totalValue = 0;
    //for (var i = 0; i < option_data.length; i++) {
    //tempArray.push([option_data[i].organization, parseInt(option_data[i].happinessRate)]);
    //}
    tempArray.push({ name: 'Government', value: option_data[0].noOfGovernment }, { name: 'Private', value: option_data[0].noOfPrivate }, { name: 'Semi Government', value: option_data[0].noOfSemiGovernment });
    totalValue = option_data[0].noOfGovernment + option_data[0].noOfPrivate + option_data[0].noOfSemiGovernment;
    //echarts starts
    this.chartOptiondashboardChart = {
      tooltip: {
        trigger: "item",
        formatter: "{c}",
        textStyle: {
          fontWeight: "bold",
          fontSize: 13
        }
      },

      legend: {
        bottom: '0',
        left: 'center',
        //orient: "vertical",

        //padding: [
        //  20,  // up
        //  20, // right
        //  0,  // down
        //  0, // left
        //],
      },
      color: ['#68b097', '#83ceb1', '#aaebac', '#f5d17a', '#efa96c', '#de8060', '#a44b2d', '#428893'],
      series: [
        {
          name: '',
          type: 'pie',
          radius: ['30%', '80%'],
          center: ["50%", "45%"],
          avoidLabelOverlap: false,
          label: {
            show: true,
            position: 'inside',
            color: '#fff',
            fontSize: '12',
            formatter: function (d) {
              return Math.round((d.value / totalValue) * 100) + '%';
            }
          },
          emphasis: {
            label: {
              show: true,
              fontSize: '10',
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: true
          },

          data: tempArray
        }
      ]
    };
    // echarts ends

    //const chart = new google.visualization.PieChart(document.getElementById('dashboardChart'));
    //chart.draw(data, options);
  }

  conductedMeetingChart = (option_data: any) => {
    


    let tempArray = [];
    let tempArray_Year = [];
    let tempArray_Happiness = [];
    for (var i = 0; i < option_data.length; i++) {
      if (parseInt(option_data[i].noofMeeting) > 0) {
        tempArray_Happiness.push(parseInt(option_data[i].noofMeeting));
        tempArray_Year.push(option_data[i].year)
      }
    }
    //tempArray.push({ name: "No of Meeting", type: 'bar', data: tempArray_Happiness });
    tempArray.push({ name: "Meeting", type: 'bar', data: tempArray_Happiness, label: { show: true, position: 'top' } });

    //echarts starts
    this.chartOptionconductedMeetingChart = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          crossStyle: {
            color: '#999'
          }
        }
      },
      color: ['#68b097', '#83ceb1', '#aaebac', '#f5d17a', '#efa96c', '#de8060', '#a44b2d', '#428893'],
      grid: {
        left: '5%',
        top: '10%',
        right: '0',
        bottom: '20%',
        containLabel: true
      },
      toolbox: {
        feature: {

          //magicType: { show: true, type: ['line', 'bar'] },
          //restore: { show: true },
          //saveAsImage: { show: true }
        }
      },
      //legend: {
      //  data: ['No of Meeting'],
      //  bottom: '0',
      //  left: 'center',
      //  //padding: [
      //  //  20,  // up
      //  //  0, // right
      //  //  0,  // down
      //  //  0, // left
      //  //],
      //},
      barWidth: "20%",
      xAxis: {
        name: 'Year',
        nameLocation: 'middle',
        nameGap: 40,
        type: 'category',
        data: tempArray_Year
      },
      yAxis: {
        name: 'No of meeting',
        nameLocation: 'middle',
        nameGap: 40,
        type: 'value'
      },
      series: tempArray

    };
    // echarts ends
    //const chart = new google.visualization.ComboChart(document.getElementById('conductedMeetingChart'));
    //chart.draw(data, options);
  }
  //* Outgoing Chart --End *//


  getDivisions() {

    let inpValue = new division();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 5;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getDivisions(inpValue)
      .subscribe(data => {

        this.division_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  getBenchMarkYear() {
    
    let date = new Date();
    let pastYear = date.getFullYear() - 1;
    let currentYear = date.getFullYear();
    let futureYear = date.getFullYear() + 1;

    this.benchMarkYear_data = [
      { text: pastYear, value: pastYear },
      { text: currentYear, value: currentYear },
      { text: futureYear, value: futureYear }
    ];
  }

  onChangeFilter() {
    
    let temp = this;
    this.spinner.show();
    setTimeout(function () {
      temp.getPerformanceDashboard();
      temp.getPracticeDashboardChart();
      temp.getPraticeBMTrackingDashboardChart();
      temp.getBMIncomingDashboardList();
      temp.getBMOutgoingDashboardList();

    }, 1000)
  }

  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }




  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val.trim();
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }


  nameFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return '<div class="e-image"><img class="e-avatar" src="' + dataContext.userPhoto + '" alt="user"></div><span class="name"> ' + dataContext.displayNameEn + '</span>';
  };




  changeChart(e: any, type: any) {
    if (type == 'performance') {
      this.hideChart();
      this.isPerformance = true;
      this.isPerformance_Option1 = true;
      this.isPerformance_Option2 = true;
      this.isPerformance_Option3 = true;
      this.getPerformanceDashboard();
    }
    else if (type == 'practice') {
      this.hideChart();
      this.isPractice = true;
      this.isPractice_Option1 = true;
      this.isPractice_Option2 = true;
      this.getPracticeDashboardChart();
      this.getPraticeBMTrackingDashboardChart();
    }
    else if (type == 'incoming') {
      this.hideChart();
      this.isIncoming = true;
      this.isIncoming_Option1 = true;
      this.isIncoming_Option2 = true;
      this.isIncoming_Option3 = true;
      this.isIncoming_Option4 = true;
      this.isIncoming_Option5 = true;
      this.getBMIncomingDashboardList();
    }
    else if (type == 'outgoing') {
      this.hideChart();
      this.isOutgoing = true;
      this.isOutgoing_Option1 = true;
      this.isOutgoing_Option2 = true;
      this.getBMOutgoingDashboardList();
    }
  }
  changeChartItem(e: any, type: any) {

    
    //isPerformance
    if (this.isPerformance) {
      if (type == 'option1') {

        this.isPerformance_Option1 = (e.target.checked) ? true : false;
      }

      if (type == 'option2') {
        this.isPerformance_Option2 = (e.target.checked) ? true : false;
      }
      if (type == 'option3') {
        this.isPerformance_Option3 = (e.target.checked) ? true : false;
      }


      this.isPerformancePageBreak = (this.isPerformance_Option1 && this.isPerformance_Option2 && this.isPerformance_Option3) ? true : false;


    }

    //isPractice
    if (this.isPractice) {
      if (type == 'option1') {

        this.isPractice_Option1 = (e.target.checked) ? true : false;
      }

      if (type == 'option2') {
        this.isPractice_Option2 = (e.target.checked) ? true : false;
      }

    }

    //isIncoming
    if (this.isIncoming) {
      if (type == 'option1') {

        this.isIncoming_Option1 = (e.target.checked) ? true : false;
      }

      if (type == 'option2') {
        this.isIncoming_Option2 = (e.target.checked) ? true : false;
      }
      if (type == 'option3') {
        this.isIncoming_Option3 = (e.target.checked) ? true : false;
      }
      if (type == 'option4') {
        this.isIncoming_Option4 = (e.target.checked) ? true : false;
      }
      if (type == 'option5') {
        this.isIncoming_Option5 = (e.target.checked) ? true : false;
      }
      if (this.isIncoming_Option1 && this.isIncoming_Option2 && this.isIncoming_Option3) {
        this.isIncomingPageBreak1 = true;
        this.isIncomingPageBreak2 = false;
      }
      else if (this.isIncoming_Option1 && this.isIncoming_Option2 && this.isIncoming_Option4) {
        this.isIncomingPageBreak1 = true;
        this.isIncomingPageBreak2 = false;
      }
      else if (this.isIncoming_Option1 && this.isIncoming_Option3 && this.isIncoming_Option4) {
        this.isIncomingPageBreak1 = false;
        this.isIncomingPageBreak2 = true;
      }
      else if (this.isIncoming_Option2 && this.isIncoming_Option3 && this.isIncoming_Option4) {
        this.isIncomingPageBreak1 = false;
        this.isIncomingPageBreak2 = true;
      }

    }

    //isOutgoing
    if (this.isOutgoing) {
      if (type == 'option1') {

        this.isOutgoing_Option1 = (e.target.checked) ? true : false;
      }

      if (type == 'option2') {
        this.isOutgoing_Option2 = (e.target.checked) ? true : false;
      }

    }

  }
  hideChart() {
    this.isPerformance = false;
    this.isPractice = false;
    this.isIncoming = false;
    this.isOutgoing = false;
  }

  exportToPDF() {
    this.loading = true;
    //pdfMake.vfs = pdfFonts.pdfMake.vfs;
    //var htmlContent = htmlToPdfmake(document.getElementById('divImcomingChart'));
    ////var htmlContent = htmlToPdfmake('<p>Kamaraj PDF</p>');
    //var docDefinition = {
    //  content: [
    //    htmlContent
    //  ],
    //  pageBreakBefore: function (currentNode) {
    //    return currentNode.style && currentNode.style.indexOf('pdf-pagebreak-before') > -1;
    //  }
    //};
    //pdfMake.createPdf(document.getElementById('divImcomingChart')).download('chart.pdf');


    var temp = this;
    //var hd = document.getElementById('divHeader');
    //hd.style.display = 'none';
    this.spinner.show();
    window.scroll(0, 0);
    let data: any;
    

    if (this.isPerformance)
      data = document.getElementById('divPerformanceChart');
    if (this.isPractice)
      data = document.getElementById('divPracticeChart');
    if (this.isIncoming)
      data = document.getElementById('divImcomingChart');
    if (this.isOutgoing)
      data = document.getElementById('divOutgoingChart');

    let strDate = new Date().getFullYear() + "" + (new Date().getMonth() + 1) + "" + new Date().getDate();


    var opt = {
      margin: 0.5,
      //filename: 'Chart-' + strDate + '.pdf',
      filename: 'Report.pdf',
      image: { type: 'jpeg', quality: 1 },
      html2canvas: { scale: 2.4, useCORS: true },
      jsPDF: { unit: 'in', format: 'a2', orientation: 'portrait' }

    };

    // New Promise-based usage:
    html2pdf().from(data).set(opt).save();
    //hd.style.display = 'block';

    setTimeout(() => {
      this.loading = false;
      temp.spinner.hide();
    }, 3000)
  }



  onchangeBMPerformance(e, type: any) {
    
    if (type == 'division') {
      this.divisionUnofilter = (e && e.length > 0 && e[0].value != null) ? e[0].value : 0;
      this.loadBenchMarkKPI();
    }

    if (type == 'kpiname') {
      let selectedKPI = [];
      for (let item of e) {
        selectedKPI.push(item.value);
      }
      this.kpiUno = (selectedKPI.length == 0) ? "" : selectedKPI.toString();
    }

    if (type == 'position') {
      this.positionUno = (e && e.length > 0 && e[0].value != null) ? e[0].value : 0;
    }

    let temp = this;
    this.spinner.show();
    setTimeout(function () {
      temp.getPerformanceDashboard();
    }, 1000)
  }

  onchangeBMPractice(e, type: any) {
    
    if (type == 'division') {
      this.divisionUnofilter = (e && e.length > 0 && e[0].value != null) ? e[0].value : 0;

    }
    let temp = this;
    this.spinner.show();
    setTimeout(function () {
      temp.getPracticeDashboardChart();
      temp.getPraticeBMTrackingDashboardChart();
    }, 1000)
  }

  onchangeBMOutgoing(e, type: any) {
    
    if (type == 'division') {
      this.divisionUnofilter = (e && e.length > 0 && e[0].value != null) ? e[0].value : 0;
    }
    if (type == 'year') {
      this.yearfilter = (e && e.length > 0 && e[0].value != null) ? e[0].value : 0;

    }
    let temp = this;
    this.spinner.show();
    setTimeout(function () {
      if (temp.isIncoming)
        temp.getBMIncomingDashboardList();
      else if (temp.isOutgoing)
        temp.getBMOutgoingDashboardList();

    }, 1000)
  }
  sentenceCase(str) {
    if ((str === null) || (str === ''))
      return false;
    else
      str = str.toString();

    return str.replace(/\w\S*/g,
      function (txt) {
        return txt.charAt(0).toUpperCase() +
          txt.substr(1).toLowerCase();
      });
  }

  exportConsolidateToPDF() {
    this.isConsolidateReport = true;
    this.loading = true;
    var temp = this;

    this.spinner.show();
    window.scroll(0, 0);
    let data: any;
    

    data = document.getElementById('divConsolidateReport');

    let strDate = new Date().getFullYear() + "" + (new Date().getMonth() + 1) + "" + new Date().getDate();


    var opt = {
      margin: 0.5,
      filename: 'ConsolidateReport.pdf',
      image: { type: 'jpeg', quality: 1 },
      html2canvas: { scale: 2.4, useCORS: true },
      jsPDF: { unit: 'in', format: 'a2', orientation: 'portrait' }

    };
    //this.loading = false;
    // New Promise-based usage:


    //hd.style.display = 'block';

    setTimeout(() => {
      this.loading = false;
      html2pdf().from(data).set(opt).save();
      this.isConsolidateReport = false;

      temp.spinner.hide();


    }, 1500)
  }
}
